// extracted by mini-css-extract-plugin
module.exports = {"Switcher":"Switcher_Switcher__WhOlw","Button":"Switcher_Button__HShuE","Active":"Switcher_Active__jfaAT"};